// Simple Backorder Modal Script
document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('.js-product-form');
  const addToCartButton = document.querySelector('.add-to-cart');
  const modal = document.getElementById('backorder-modal');
  const confirmButton = document.getElementById('backorder-confirm');
  const cancelButton = document.getElementById('backorder-cancel');
  const closeButton = document.querySelector('.backorder-modal-close');
  const overlay = document.querySelector('.backorder-modal-overlay');
  const variantPicker = document.querySelector('variant-picker');
  
  let isBackorderItem = false;
  let shouldShowModal = true;
  
  function checkBackorderStatus() {
    // Check if button text indicates backorder
    const buttonText = addToCartButton.textContent.trim().toLowerCase();
    isBackorderItem = buttonText.includes('backorder');
  }

  checkBackorderStatus();

  document.addEventListener('on:variant:change', function(e) {
    setTimeout(checkBackorderStatus, 100);
  });
  
  function showModal() {
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
  
  function hideModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
    shouldShowModal = true;
  }
  
  // Complete the add to cart process
  function completeAddToCart() {
    shouldShowModal = false; // Prevent modal from showing again
    
    // Method 1: Try submitting the form normally
    if (productForm) {
      productForm.submit();
      return;
    }
    
    // Method 2: If form submit doesn't work, try clicking the button
    if (addToCartButton) {
      addToCartButton.click();
      return;
    }
    
    // Method 3: Fallback to AJAX if other methods fail
    const formData = new FormData(productForm);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      // Refresh the page to update cart
      window.location.reload();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    });
  }
  
  if (addToCartButton) {
    addToCartButton.addEventListener('click', function(e) {
      if (isBackorderItem && shouldShowModal) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showModal();
        return false;
      }
    }, true);
  }
  
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      if (isBackorderItem && shouldShowModal) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showModal();
        return false;
      }
    }, true);
  }
  
  if (confirmButton) {
    confirmButton.addEventListener('click', function() {
      hideModal();
      completeAddToCart();
    });
  }
  
  [cancelButton, closeButton, overlay].forEach(element => {
    if (element) {
      element.addEventListener('click', hideModal);
    }
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'block') {
      hideModal();
    }
  });
});